import {CardId} from '@raison/types';
import {RsnButton, RsnDialog} from '@raison/ui-kit';
import React from 'react';
import {useDeleteCard} from '../../../../api/cardQueryHooks';

interface Props {
    cardId: CardId;
    onClose: () => void;
}

const ApproveCardDeleteModal = ({cardId, onClose}: Props) => {
    const deleteCardMutation = useDeleteCard().mutate;

    const handleDelete = () => {
        if (cardId) {
            deleteCardMutation(cardId);
        }
        onClose();
    };

    return (
        <RsnDialog.Window placement='bottom'>
            <RsnDialog.CenteredHeader icon={{element: <RsnDialog.StatusIcon status={'attention'} />}}>
                Are you sure you want to delete this card?
            </RsnDialog.CenteredHeader>
            <RsnDialog.Footer column>
                <RsnButton.Primary onClick={handleDelete}>Delete</RsnButton.Primary>
                <RsnButton.Secondary onClick={onClose}>Cancel</RsnButton.Secondary>
            </RsnDialog.Footer>
        </RsnDialog.Window>
    );
};

export default ApproveCardDeleteModal;
